import React, { useEffect, useState } from "react";
import "./main.css";
import "./main.scss";
import { HiOutlineClipboardCheck, HiOutlineLocationMarker } from "react-icons/hi";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

import { FaCalendarAlt } from "react-icons/fa";
import { FaMapMarkedAlt } from "react-icons/fa";

import truncate from "truncate-html";

import Aos from "aos";
import "aos/dist/aos.css";
import img from "../../assets/bg-1.png"
const Main = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
      fetch("https://orangered-hornet-549881.hostingersite.com/api/tours")
        .then((res) => res.json())
        .then((result) => {
          setData(result.data || []);
        })
        .catch((err) => console.error("Error fetching tours:", err));
    }, []);

  return (
    <section className="main container section">
      
      <div className="secTitle">
        <span>Popular Tours</span>
        <h2 className="title">
        Best Holidays and vacations to Egypt
        </h2>
        <p>Discover our best Egypt travel categories for Egypt trips to create your best Egypt tour plan. Experience</p>
      </div>

      <div className="secContent grid slider-container">
      {data.length > 0 ? (
    data.slice(0,8).map((trip)=> {
  const firstImage = trip.images?.length
    ? `https://orangered-hornet-549881.hostingersite.com/storage/${trip.images[0]}`
    : "https://via.placeholder.com/400x250";


            return (
              <div key={trip.id} className="tourCard">
                       {/* صورة الرحلة */}
                       <div className="tourImage">
                         <img src={firstImage} alt={trip.title} />
                         <span className="priceTag">From: {trip.pricings?.length > 0 
    ? Math.min(...trip.pricings.map(p => parseFloat(p.price_per_person))) 
    : "N/A"}$</span>
                       </div>
             
                       {/* تفاصيل الرحلة */}
                       <div className="tourContent">
                         <h3 className="tourTitle">{trip.title}</h3>
                           <p
                                  className="tourDesc"
                                  dangerouslySetInnerHTML={{
                                    __html: trip.description ? truncate(trip.description, 80) : "",
                                  }}
                                />
             
                       
             
                         {/* زرار */}
  <Link to={`/tour-details/${trip.id}`}>
  <button className="bookBtn">TOUR DETAILS</button>
</Link>
             
               </div>
                     </div>
            );
          })
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </section>
  );
};

export default Main;
